<template>
  <div class="container container-table">
      <div class="row vertical-10p">
        <div class="container">
          <img src="static/img/logo.png" class="center-block logo">
          <div class="text-center col-md-4 col-sm-offset-4">
            <!-- errors -->
            <div v-if=response class="text-red"><p>{{response}}</p></div>
            <!-- login form -->
	          <a href="#" @click='doLogin' class="btn btn-block btn-social btn-facebook btn-flat">
		          <i class="fa fa-facebook"></i> Sign in using Facebook
	          </a>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
module.exports = {
  name: 'Login',
  data: function (router) {
    return {
    }
  },
  mounted: function() {
    var self = this
    var store = this.$store
    this.$nextTick(function () {
	    (function(d, s, id) {
		    var js, fjs = d.getElementsByTagName(s)[0];
		    if (d.getElementById(id)) return;
		    js = d.createElement(s); js.id = id;
		    js.src = "//connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v2.8";
		    fjs.parentNode.insertBefore(js, fjs);
		  }(document, 'script', 'facebook-jssdk'));

		  window.fbAsyncInit = function() {
		    //SDK loaded, initialize it
		    FB.init({
		      appId      : '516682505174537',
		      xfbml      : true,
		      version    : 'v2.8'
		    });
		    self.checkLoginState();
		  };
	  });
  },
  methods: {
    doLogin: function () {
      var self = this
      var store = this.$store
      FB.login(function (response) {
        if (response.status === 'connected') {
          var accessToken = response.authResponse.accessToken;
          store.dispatch('doSetToken', accessToken )
          if (window.localStorage) window.localStorage.setItem('token', accessToken)
          self.getUserData(response.authResponse, function () {
            self.$router.push("/")
          })
        }
      })
    },
    getUserData: function (data, callback) {
      var store = this.$store
			FB.api(
			'/me',
			'GET',
			{'fields': 'id,name,first_name,last_name,email,picture'},
			function (FBResponse) {
				store.dispatch('doSetUser', FBResponse)
				// Store token in local storage
				if (window.localStorage) window.localStorage.setItem('user', JSON.stringify(FBResponse))
				callback();
			}
			) // FB.api
    },
    checkLoginState: function () {
    //check user session and refresh it
      var self = this
      var store = this.$store
      FB.getLoginStatus(function(response) {
	      if (response.status === 'connected') {
	        var accessToken = response.authResponse.accessToken;
          store.dispatch('doSetToken', accessToken )
          if (window.localStorage) window.localStorage.setItem('token', accessToken)
          self.getUserData(response.authResponse, function () {
            self.$router.push("/")
          })
	      }
      })
    }
  }
}
</script>

<style>
html, body,.container-table {
  height: 100%;
  background-color: #fff !important;
}
.container-table {
    display: table;
    color: white;
}
.vertical-center-row {
    display: table-cell;
    vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.logo {
  width: 15em;
  padding: 3em;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
}
.input-group input {
  height: 4em;
}
</style>



// WEBPACK FOOTER //
// Login.vue?59e8bb8c